import React from 'react';
import { Modal } from '@wix/design-system';
import { OneStepInstallationModalLayout } from './one-step-installation-modal-layout';
import { MODAL_DATA_HOOK } from './data-hooks';
import type { OneStepInstallationModalProps } from './types';

export function OneStepInstallationModal({
  isOpen,
  onClose,
  options,
  onLoad,
  onError,
  appId,
  origin,
}: OneStepInstallationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      dataHook={MODAL_DATA_HOOK}
    >
      <OneStepInstallationModalLayout
        onClose={onClose}
        options={options}
        onLoad={onLoad}
        onError={onError}
        appId={appId}
        origin={origin}
      />
    </Modal>
  );
}
